import React, { useContext } from 'react'
import { SecurityContext } from '../SecurityContext'

const useSecurity = () => {
    return useContext(SecurityContext)
}

export default useSecurity
